<template>
    <div :class="phoneClass || 'device-wrapper'">
        <div v-if="phoneClass" class="title">
            {{$t("header.device")}}
        </div>
        <content-header @changeList="changeList" class="device-content-header-wrapper">

            <div v-if="roleShow && !phoneClass">
                <el-button type="primary" class="normal-button" style="margin-right:10px;" @click="downloadFile" v-if="user.role === 100">
                    <img src="../../assets/img/btn/icon-download.png">
                    <span class="text">{{$t("sideBar.download")}}</span>
                </el-button>

                <el-dropdown v-if="user.role === 100 ">
                    <el-button type="primary" class="normal-button" style="margin-right:10px;" >
                        <img src="../../assets/img/btn/icon-export.png">
                        <span class="text">{{$t("sideBar.upload")}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item >
                            <el-upload style="display:inline-block;margin-right:5px;"
                                :action="fileUrl"
                                :on-success="onFileUploadSuccessEvent"
                                :before-upload="beforeAvatarUpload"
                                ref="el-upload"
                                :show-file-list="false" :auto-upload="true">
                                <span class="text" >{{$t("sideBar.uploadNB")}}</span>
                            </el-upload>
                        </el-dropdown-item>
                        <el-dropdown-item >
                            <el-upload style="display:inline-block;margin-right:5px;"
                                :action="fileLoraUrl"
                                :on-success="onFileUploadSuccessEvent"
                                :before-upload="beforeAvatarUpload"
                                ref="el-upload"
                                :show-file-list="false" :auto-upload="true">
                                <span class="text" >{{$t("sideBar.uploadLora")}}</span>
                            </el-upload>
                        </el-dropdown-item>
<!--                        <el-dropdown-item v-if="user.role === 101">-->
<!--                            <el-upload style="display:inline-block;margin-right:5px;"-->
<!--                                       :action="fileStorageLoraUrl"-->
<!--                                       :on-success="onFileUploadSuccessEvent"-->
<!--                                       :before-upload="beforeAvatarUpload"-->
<!--                                       ref="el-upload"-->
<!--                                       :show-file-list="false" :auto-upload="true">-->
<!--                                <span class="text" >{{$t("sideBar.uploadLoraStorage")}}</span>-->
<!--                            </el-upload>-->
<!--                        </el-dropdown-item>-->
                    </el-dropdown-menu>
                </el-dropdown>

                <el-button  class="normal-button" @click="goDeviceEdit" v-if="user.role === 100 ">
                    <img src="../../assets/img/btn/icon-add.png">
                    <span class="text">{{$t("sideBar.newEquipment")}}</span>
                </el-button>
            </div>
        </content-header>
        <div class="table-wrapper">
            <device-table  pageType='device'></device-table>
        </div>
    </div>
</template>
<script>
import Core from 'core/core'
import contentHeader from '../../components/content-header'
import deviceTable from '../../components/device-table'

import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
            user: '',
            roleShow: false,
            fileUrl: '',
            fileLoraUrl: '',
            fileStorageLoraUrl: '',
            loading: '',
            handleList: 1,
        };
    },
    components: {
        contentHeader,
        deviceTable
    },
    created(){
	    refresh(this,'phoneClass-device');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-device');
		    },10)
	    };
    },
    mounted() {
	    this.initFileUrl()
	    this.initUser()
    },
    methods: {
        initFileUrl() {
	        let token = Core.Data.getToken()
	        this.fileUrl = Core.Const.NET.END_POINT + '/device/import-device-file?token=' + token
            this.fileLoraUrl = Core.Const.NET.END_POINT + '/device/import-device-lora-file?token=' + token
            this.fileStorageLoraUrl = Core.Const.NET.IMPORT_FILE + 'import-storage-lora?token=' + token
            console.log("this.fileStorageLoraUrl", this.fileStorageLoraUrl)
            console.log("this.IMPORT_FILE", Core.Const.NET.IMPORT_FILE)
        },
        initUser (){
            this.user = Core.Data.getUser()
            if (this.user.role !== 102 && this.user.role !== 101) {
                this.roleShow = true
            }
        },
        goDeviceEdit(row) {
            let id = 0;
            if(row.id) {
                id = row.id
            }
            this.$router.push(`/device/add${id?'?device_id='+id : ''}`)
        },
        downloadFile(){
            const lang = Core.Data.getLang() || 'zh'
            window.open(`/template/${lang}/device-excel-template.xlsx`)
        },
        onFileUploadSuccessEvent(res, file, fileList){
            if(!file.response.data) {
                if (res.message) {
                    this.$message.error(res.message)
                } else {
                    this.$message.error('导入失败,请查看文件内容格式')
                }
            }else {
                console.log(res,'文件上传')
                if (res.data.fail_list[0]) {
                    let msg = ''
                    for(let i in res.data.fail_list) {
                        let item = res.data.fail_list[i]
                        item.imei ? msg += 'Excel表格第'+item.row_num+'行，'+ Object.keys(item)[1] +':'+item.imei+'，'+item.message+'</br>'
                            : msg += 'Excel表格第'+item.row_num+'行，'+ Object.keys(item)[1] +': &nbsp;&nbsp; ，'+item.message+'</br>'
                        // : msg += '第'+item.row_num+'行，'+item.message+'</br>'
                        // msg += '第'+item.row_num+'行，编号:'+item.imei+'，'+item.message+'</br>'
                    }
                    let div = '<div style="min-height:300px;height:50vh;overflow: auto">' + msg + '</div>'
                    this.$alert(div, '部分设备未导入原因：', {
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    this.$message.success('导入成功');
                    window.location.reload()
                }
            }
            this.loading.close();
            console.log(res,'res')
            console.log(file,'file')
        },
        beforeAvatarUpload(file){
	        console.log(file.name.substr(file.name.lastIndexOf(".")),'文件格式')
	        let EXCEL = file.name.substr(file.name.lastIndexOf("."))
	        let isEXCEL  = EXCEL === '.xls' || EXCEL === '.xlsx'
            if (isEXCEL){
                this.loading= this.$loading({
                    lock: true,
                    text: 'Up loading'
                })
            } else {
                this.$message.error('请导入excel表格')
                return isEXCEL;
            }
        },
        changeList(e) {
            this.handleList = e
        }
    },
}
</script>

<style scoped lang="scss">
.device-wrapper {
    background-color: #E5EBEF;
    height: 100%;
    .normal-button {
        border: white 1px solid;
        background-color: transparent;
        img {
            width: 13px;
            height: 13px;
            vertical-align: middle;
        }
        .text {
            font-size: 14px;
            color: #FFFFFF;
            vertical-align: middle;
            margin-left: 8px;
            line-height: 20px;
        }
    }
    .table-wrapper {
        margin: 30px 40px;
        background-color: #FFFFFF;
    }
}
</style>
<style lang="scss">
.phoneClass-device {
    .phoneClass-content-header-wrapper {
        position: relative;
        background-color: #0A3D95;
        margin-bottom: 10px;
        padding: 8px 0;
        .header-right {
            width: 90%;
            position: absolute;
            left: 3px;
            bottom: 3px;
            .el-button {
                margin: 0 0 !important;
                padding: 5px !important;
                min-width: 90px;
                border-color: white;
                background-color: #0A3D95;
                img {
                    width: 12px;
                }
            }
            >div {
                margin: 0 !important;
                width: 100%;
                display: flex;
                justify-content: space-between;
                >div {
                    .el-button {
                        padding: 5px 0 !important;
                        min-width: 80px;
                        margin: 0 3px !important;
                    }
                }
            }
            .el-button:nth-child(3) {
                /*min-width: 80px;*/
                color: white;
            }
        }
        // .title_tab {
        //     padding: 6px;
        //     vertical-align: middle;
        //     font-size: 16px;
        //     color: #fff;
        //     font-weight: 500;
        //     border-radius: 2px;
        // }
        // .title_tab_pitch {
        //     padding: 6px;
        //     vertical-align: middle;
        //     font-size: 16px;
        //     color: #0A3D95;
        //     font-weight: 500;
        //     background: #fff;
        //     border-radius: 2px;
        // }
    }

    .title {
        display: flex;
        align-items: center;
        padding-left: 15px;
        min-height: 46px;
        font-weight: 600;
        color: #353C41;
        font-size: 20px;
        background-color: #fff;
    }
    .table-wrapper {
        .search-bar {
            padding-left: 10px;
        }
        .superBtn {
            .status-index {
                .el-select {
                    width: 70%;
                }
            }
        }
    }
    .pagination {
        padding: 20px 0 !important;
        text-align: center !important;
        .el-pagination {
            padding: 0;
            button {
                width: 20px;
                min-width: 0;
                height: 30px;
            }
            .el-pager {
                .number {
                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
                .el-icon-more {

                    margin: 0 3px !important;
                    padding: 0 !important;
                    min-width: 0px;
                    width: 20px !important;
                    height: 30px !important;
                }
            }
        }
    }

}

</style>
